<div class="container clearfix" (keydown)="validateKeyDown($event)">
    <div class="row">
        <div class="col-md-12">
            <div class="div-svg mt-5 mb-3" tabindex="-1">
                <img *ngIf="brandImageLoaded" alt="{{'LOGO' | translate}}" class="login-logo" [src]="brandImageUrl">
            </div>
        </div>
        <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto" style="margin-top:-40px;max-width:600px"
            [ngClass]="{'mt-5': !brandImageLoaded}">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-12">
                            <h4 *ngIf="totpState === 0">{{ 'TWOFA-SUB-TITLE' | translate }}</h4>
                            <h4 *ngIf="totpState === 1">{{ 'SELECT-METHOD' | translate }}</h4>
                            <h4 *ngIf="totpState === 2">{{ 'ENTER-CODE' | translate }}</h4>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <!--Authenticator App form-->
                    <form [formGroup]="formAuthenticator" class="k-form" *ngIf="totpState === 0 || totpState === 2">
                        <div class="m-2">
                            <kendo-maskedtextbox #maskedinput formControlName="verificationCode" [mask]="mask"
                                class="mt-3" style="font-size: larger;width: 140px;padding-left: 25px;">
                            </kendo-maskedtextbox>
                            <div class="validation-error" *ngIf="invalidCode">{{ 'CODE-INVALID' | translate }}</div>
                            <div class="validation-error"
                                [hidden]="verificationCode.valid || !verificationCode.touched">
                                {{ 'MUST-ENTER-TWOFA-CODE' | translate }}
                            </div>
                        </div>
                    </form>
                    <!--Alternate Code form-->
                    <form [formGroup]="formAlternativeAuth" class="k-form" *ngIf="totpState === 1">
                        <div class="m-2">
                            <div *ngIf="sms.value" class="row">
                                <div class="float-left">
                                    <input type="radio" value="sms" name="methodRequest" formControlName="methodRequest"
                                        id="methodSMS" kendoRadioButton />
                                    <label class="k-radio-label" for="methodSMS"><i class="fal fa-mobile"
                                            style="width: 30px;text-align: center;"></i>
                                        {{sms.value | phone | maskInput }}
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="email.value" class="row">
                                <div class="float-left">
                                    <input type="radio" value="email" name="methodRequest"
                                        formControlName="methodRequest" id="methodEmail" kendoRadioButton />
                                    <label class="k-radio-label" for="methodEmail"><i class="fal fa-envelope"
                                            style="width: 30px;text-align: center;"></i>
                                        {{email.value | maskInput}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="mb-2">
                        <button kendoButton (click)="cancel()" class="float-center k-text-uppercase">
                            {{ 'CANCEL' | translate }}
                        </button>
                        <button *ngIf="totpState === 0 || totpState === 2" kendoButton appPreventClick
                            (click)="validate()"
                            [disabled]="!formAuthenticator.valid || !formAuthenticator.dirty || validating || verificationCode.value.length !== 6"
                            [primary]="true" class="ml-4 float-center k-text-uppercase">
                            <span class="pl-2">{{ 'LOGIN' | translate }}</span>
                            <i class="far fa-sign-in-alt" *ngIf="!validating"></i>
                            <i class="k-icon k-i-loading" *ngIf="validating"></i>
                        </button>
                        <button *ngIf="totpState === 1" kendoButton appPreventClick (click)="sendCode()"
                            [disabled]="!formAlternativeAuth.valid" [primary]="true"
                            class="ml-4 float-center k-text-uppercase">
                            <span class="pl-2">{{ 'SEND-CODE' | translate }}</span>
                        </button>
                        <button *ngIf="totpState === 1 && totpSentCodeCount > 0" kendoButton appPreventClick
                            (click)="enterCode()" [disabled]="!formAlternativeAuth.valid" [primary]="true"
                            class="ml-4 float-center k-text-uppercase">
                            <span class="pl-2">{{ 'ENTER-CODE' | translate }}</span>
                        </button>
                    </div>
                    <div *ngIf="differentAuthMethodAllowed && totpState === 0" class="pt-2"
                        style="text-align:center;padding-left: 25px;">
                        <span class="underline" (click)="performAlternativeAuth()">
                            {{ 'SEND-CODE-USING-ALTERNATIVE-METHOD' | translate }}
                        </span>
                    </div>
                    <!--QR Code visible only if changed and returned from the authentication-->
                    <div *ngIf="showQRCode && totpState === 0" class="pt-2"
                        style="text-align:center;padding-left: 25px;">
                        <span class="underline font-weight-bold" (click)="toggleQRCode()">
                            {{ (qrCodeVisible ? 'HIDE-QRCODE' : 'SHOW-QRCODE') | translate }}
                        </span>
                        <div *ngIf="qrCodeVisible">
                            <div class="text-center">
                                <img alt="{{'QRCODE' | translate}}" class="qrcode-image m-2" [src]="qrCodeImageUrl">
                            </div>
                            <div class="text-center">
                                <i class="fa fa-info-circle"></i><span class="montserrat ml-1">
                                    {{'QRCODE-DESCRIPTION' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Select Active Roles Dialog-->
<app-select-role #selectRole></app-select-role>
<!--Select Active Organizations Dialog-->
<app-select-organization #selectOrganization></app-select-organization>
<!--Change User Password Dialog-->
<app-change-password #changePassword></app-change-password>